module.exports = __webpack_public_path__ + "static/media/school.930ea92d.svg";